<template>
  <nav>
    <div
      v-if="!loadingData"
      class="fill-height"
      :class="mobileOverride() ? 'activity-page-container-mobile' : 'activity-page-container'"
    >
      <AlertMessages
        v-if="alertValue"
        :alert-type="alertType"
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />

      <!-- show draft tag -->
      <v-row
        v-if="draftVersion && role == 'booster' && !mobile()"
        no-gutters
        class="text-right custom-draft-tag custom-draft-tag-style-more-right"
      >
        <v-col cols="12">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip
                v-if="published"
                data-testid="draft-available-chip"
                color="primary"
                text-color="white"
                v-on="on"
              >
                {{ $t("draftAvailableTag") }}
              </v-chip>
              <v-chip
                v-else
                data-testid="draft-available-chip"
                color="warning"
                text-color="black"
                v-on="on"
              >
                {{ $t("draftAvailableTag") }}
              </v-chip>
            </template>
            <span>{{ $t("draftAvailableTooltip") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <!-- end show draft tag -->
      <!--not booster view -->
      <v-row
        v-if="hasContent && role != 'booster'"
        class="greyactivitybackground fill-height"
        no-gutters
      >
        <v-col
          cols="12"
          class="fill-height mr-n2"
          :class="!mobile() ? 'px-3' : ''"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''"
        >
          <v-card
            ref="viewPage"
            max-width="960px"
            elevation="0"
            :rounded="!mobile() ? 'xxl' : ''"
            class="mx-auto fill-height view-checklist"
            :class="!mobile() ? 'py-12' : 'py-16'"
            :style="mobile() ? 'padding-top: 96px' : ''"
          >
            <div
              v-if="imageUrl != null"
              data-testid="checklist-image"
            >
              <v-img 
                :src="imageUrl" 
                width="100%"
                max-height="330px"
              />
            </div>
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="description != null"
              :class="mobileOverride() ? 'px-4' : 'px-8'"
              class="py-4"
              data-testid="checklist-description"
              v-html="description"
            />
            <div
              v-if="checklist.length > 0"
              data-testid="checklist-items"
              :class="mobileOverride() ? 'px-4' : 'px-8'"
              class="py-4"
            >
              <div
                v-for="(element, index) in checklist"
                :key="index"
                class="content-block"
                data-testid="checklist-item"
              >
                <!-- eslint-disable vue/no-v-html -->
                <v-divider class="mx-md-8" />   
                <div :class="mobileOverride() ? '' : 'px-8'"  class="py-3 checkbox-align-start">
                  <v-checkbox
                    v-model="element.attributes.checked"
                    :off-icon="'mdi-square-rounded-outline'"
                    hide-details
                    class="shrink mt-0 checklist-off-icon"
                    color="success"
                    data-testid="checklist-item-checkbox"
                    @change="setCheckitem(element.attributes.checked, element.id)"
                  >
                    <template v-slot:label>
                      <p
                        class="font-weight-bold ml-2 mb-0 no-break"
                        :class="element.attributes.checked ? 'text-decoration-line-through greytext--text' : ''"
                      >
                        {{ element.attributes.title }}
                      </p>
                    </template>
                  </v-checkbox>
                  <div
                    class="ml-10"
                    v-html="element.attributes.content"
                  />
                </div>
              </div>
              <div :class="mobileOverride() ? 'px-6' : 'px-8'"  class="pt-3">
                <v-btn
                  data-testid="reset-button"
                  outlined
                  elevation="0"
                  class="rounded-xxl text-none"
                  color="greytext"
                  style="background:#fafafa"
                  @click="resetChecklist()"
                >
                  {{ $t('reset') }}
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        v-if="noPublishedItems == true && role != 'booster'"
        class="fill-height"
        align="center"
        data-testid="no-published-content"
      >
        <v-col cols="12" class="py-12 px-0" align="center">
          <EmptyPage
            :page-title="$t('noPublishedItemsTitle')"
            :page-text="$t('noPublishedItemsText')"
            page-image="image4"
          />
        </v-col>
      </v-row>
      <v-row
        v-if="lockedContent && !noPublishedItems && role != 'booster'"
        class="greyactivitybackground fill-height"
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          :class="!mobile() ? 'px-3 mr-n2 fill-height' : 'mr-n2 fill-height'"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''"
        >
          <LockedContent
            max-width="960px"
            elevation="0"
            class="fill-height"
            :content="requiredContent"
            :type="lockType"
          />
        </v-col>
      </v-row>
      <!--end not booster view -->
      <!-- booster view -->
      <v-row
        v-if="role=='booster'"
        class="greyactivitybackground fill-height"
        no-gutters
      >
        <v-col
          cols="12"
          class="mr-n2 fill-height"
          :class="!mobile() ? 'px-3' : ''"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''"
        >
          <div class="text-center d-none d-md-block">
            <ActivityViewToggle @toggleView="changeView"/>
          </div>
          <v-tabs
            v-model="tabs"
            right
            slider-color="white"
            slider-size="0px"
            :background-color="!mobile() ? 'greyactivitybackground' : ''"
            active-class="tab-version-active"
            class="mx-auto fill-height view-checklist overflow-hidden"
            data-testid="show-tabs"
            :class="screen"
          >

            <v-tab
            v-if="hasContent"
              v-show="!mobile()"
              href="#publish"
              style="border-radius: 8px 8px 0 0"
              class="tab-version publish"
               data-testid="published-tab"
            >
              {{ $t('published') }}
            </v-tab>

            <v-tab
            v-if="draftVersion || editButtonColor == 'warning'"
              v-show="!mobile()"
              href="#draft"
              :style="!mobile() ? 'color: #fbc02d; border-radius: 8px 8px 0 0' : ''"
              class="tab-version draft"
              data-testid="draft-tab"
            >
              {{ $t('draft') }}
            </v-tab>

            <v-tabs-items v-model="tabs" :class="!mobile() ? 'rounded-xxl' : 'fill-height'">
              <v-tab-item
                v-if="hasContent"
                value="publish"
                key="publish"
                :transition="false"
                reverse-transition="false"
                :style="!mobile() ? 'border: 2px solid #F4F5F5;' : ''"
              >
                <div class="mobile-view-scroll-inside rounded-xxl">
                  <v-card
                    ref="viewPage"
                    elevation="0"
                    class="mx-auto fill-height view-checklist rounded-xxl pb-12"
                    :class="{'pt-12': !mobileOverride(), 'pt-4': mobileOverride(), 'mobile-view-simulator': screen == 'mobile-view'}"
                  >
                    <div v-if="imageUrl != null" data-testid="checklist-image">
                      <v-img :src="imageUrl" width="100%" max-height="330px" />
                    </div>
                    <!-- eslint-disable vue/no-v-html -->
                    <div
                      v-if="description != null"
                      :class="mobileOverride() ? 'px-4' : 'px-8'"
                      class="py-4"
                      data-testid="checklist-description"
                      v-html="description"
                    />
                    <div
                      v-if="checklist.length > 0"
                      data-testid="checklist-items"
                      class="py-4"
                      :class="mobileOverride() ? 'px-4' : 'px-8'"
                    >
                      <div
                        v-for="(element, index) in checklist"
                        :key="index"
                        class="content-block"
                        data-testid="checklist-item"
                      >
                        <!-- eslint-disable vue/no-v-html -->
                        <v-divider class="mx-md-8" />
                        <div :class="mobileOverride() ? '' : 'px-8'"  class="py-3 checkbox-align-start">
                          <v-checkbox
                            v-model="element.attributes.checked"
                            :off-icon="'mdi-square-rounded-outline'"
                            hide-details
                            class="shrink mt-0 checklist-off-icon"
                            color="success"
                            data-testid="checklist-item-checkbox"
                            @change="
                              setCheckitem(element.attributes.checked, element.id)
                            "
                          >
                            <template v-slot:label>
                              <p
                                class="font-weight-bold ml-2 mb-0 no-break"
                                :class="
                                  element.attributes.checked
                                    ? 'text-decoration-line-through greytext--text'
                                    : ''
                                "
                              >
                                {{ element.attributes.title }}
                              </p>
                            </template>
                          </v-checkbox>
                          <div
                            class="ml-10"
                            v-html="element.attributes.content"
                          />
                        </div>
                      </div>
                      <div :class="mobileOverride() ? '' : 'px-8'"  class="pt-3">
                        <v-btn
                          data-testid="reset-button"
                          outlined
                          elevation="0"
                          class="rounded-xxl text-none px-6"
                          color="greytext"
                          style="background: #fafafa"
                          @click="resetChecklist()"
                        >
                          {{ $t("reset") }}
                        </v-btn>
                      </div>
                    </div>
                  </v-card>
                </div>
              </v-tab-item>
              <v-tab-item
                v-else
                value="publish"
                key="publish"
                :transition="false"
                reverse-transition="false"
                :style="!mobile() ? 'border: 2px solid #F4F5F5;' : ''"
              >
                <EmptyPageActivity
                  elevation="0"
                  class="mx-auto fill-height"
                  align="center"
                  :page-title="$t('emptyActivityChecklistTitle')"
                  :page-text="$t('emptyActivityChecklistText')"
                  page-image="image4"
                  :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''"
                />
              </v-tab-item>
              <v-tab-item
                v-if="draftVersion"
                value="draft"
                key="draft"
                :transition="false"
                reverse-transition="false"
                class="rounded-xxl"
                :style="!mobile() ? 'border: 2px solid #fbc02d;' : ''"
              >
                <div class="mobile-view-scroll-inside rounded-xxl">
                  <v-card
                    ref="viewPage"
                    elevation="0"
                    class="mx-auto fill-height view-checklist rounded-xxl pb-12"
                    :class="{'pt-12': !mobileOverride(), 'pt-4': mobileOverride(), 'mobile-view-simulator': screen == 'mobile-view'}"
                  >
                    <div v-if="imageUrlDraft != null" data-testid="checklist-image">
                      <v-img :src="imageUrlDraft" width="100%" max-height="330px" />
                    </div>
                    <!-- eslint-disable vue/no-v-html -->
                    <div
                      v-if="descriptionDraft != null"
                      class="py-4"
                      :class="mobileOverride() ? 'px-4' : 'px-8'"
                      data-testid="checklist-description"
                      v-html="descriptionDraft"
                    />
                    <div
                      v-if="checklistDraft.length > 0"
                      data-testid="checklist-items"
                      class="py-4"
                      :class="mobileOverride() ? 'px-4' : 'px-8'"
                    >
                      <div
                        v-for="(element, index) in checklistDraft"
                        :key="index"
                        class="content-block"
                        data-testid="checklist-item"
                      >
                        <!-- eslint-disable vue/no-v-html -->
                        <v-divider class="mx-md-8" />
                        <div :class="mobileOverride() ? '' : 'px-8'" class="py-3 checkbox-align-start">
                          <v-checkbox
                            v-model="element.checked"
                            :off-icon="'mdi-square-rounded-outline'"
                            hide-details
                            class="shrink mt-0 checklist-off-icon"
                            color="success"
                            disabled
                            data-testid="checklist-item-checkbox"
                            @change="
                              setCheckitem(element.checked, element.id)
                            "
                          >
                            <template v-slot:label>
                              <p
                                class="font-weight-bold ml-2 mb-0 no-break"
                                :class="
                                  element.checked
                                    ? 'text-decoration-line-through greytext--text'
                                    : ''
                                "
                              >
                                {{ element.title }}
                              </p>
                            </template>
                          </v-checkbox>
                          <div
                            class="ml-10"
                            v-html="element.content"
                          />
                      </div>
                    </div>
                    </div>
                  </v-card>
                </div>
              </v-tab-item>
              <v-tab-item
                v-else
                value="draft"
                key="draft"
                :transition="false"
                reverse-transition="false"
                :class="!mobile() ? 'rounded-xxl' : 'fill-height'"
                :style="!mobile() ? 'border: 2px solid #fbc02d;' : ''"
              >
                <EmptyPageActivity
                  elevation="0"
                  class="mx-auto fill-height"
                  align="center"
                  :page-title="$t('emptyActivityChecklistTitle')"
                  :page-text="$t('emptyActivityChecklistText')"
                  page-image="image4"
                  :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''"
                />
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-col>
      </v-row>
      <v-card
        ref="viewNavigationButtons"
        max-width="960px"
        elevation="0"
        class="mx-auto"
        v-if="role != 'booster' && !loadingData"
      >
        <NavigationBackButton
          :activity-pages="activity_pages"
        />
        <NavigationNextButton
          :activity-pages="activity_pages"
        />
      </v-card>

      <EditButtonWithLinkInActivity
        v-if="isAuth && role == 'booster' && !mobile()"
        data-testid="edit-checklist-button"
        rounded="xxl"
        :class="editButtonTextColor"
        :color="editButtonColor"
        :link="{title: '', route: '/activity/'+$route.params.id+'/checklist/'+$route.params.checklistId+'/edit'}"
        :classes="'edit-activity'"
        @openPreventEditingDialog="dialogVisible=true"
      />
      <ConfirmationDialog 
        v-if="dialogVisible"
        ref="confirmationDialog"
        :visible="dialogVisible" 
        :cd-title="confirmationDialogTitle" 
        :cd-text="confirmationDialogText" 
        :cd-submit-btn="confirmationDialogSubmitBtn" 
        :cd-cancel-btn="confirmationDialogCancelBtn"
        :cd-submit-btn-color="cdSubmitBtnColor" 
        data-testid="confirmation-dialog" 
        @close="dialogVisible=false"
        @proceedSubmit="dialogVisible=false"
      />
    </div>
  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import { getActivity,getChecklistItemsAll, getActivityPages, getActivityChecklist, getChecklistItems, checkitemAttempt, changeImageInChecklist, resetChecklist } from '../../api/activityApi'
import {eventBus} from '../../eventbus'
import EmptyPage from '../../components/EmptyPage'
import EmptyPageActivity from '../../components/EmptyPageActivity'
import NavigationNextButton from '../../components/NavigationNextButton'
import EditButtonWithLinkInActivity from '../../components/EditButtonWithLinkInActivity'
import AlertMessages  from '../../components/AlertMessages'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import LockedContent from '../../components/LockedContent'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import moment from 'moment'
import NavigationBackButton from '../../components/NavigationBackButton'
import ActivityViewToggle from '../../components/ActivityViewToggle'

export default {
    components: {
        EmptyPage,
        EmptyPageActivity,
        NavigationNextButton,
        EditButtonWithLinkInActivity,
        AlertMessages,
        LockedContent,
        ConfirmationDialog,
        NavigationBackButton,
        ActivityViewToggle
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            isAuth: window.$cookies.get("token")? true: false,
            checkboxCertificate: false,
            loadingData: false,
            spaceId: window.$cookies.get('space_id'),
            activityId: this.$route.params.id,
            pageId: this.$route.params.pageId,
            quizId: this.$route.params.quizId,
            scormId: this.$route.params.scormId,
            checklistId: this.$route.params.checklistId,
            alertMsg: '',
            alertValue:false,
            alertType: '',
            activity_pages: [],
            hasContent: false,
            role:'',
            published: false,
            editButtonColor: 'warning',
            editButtonTextColor: 'black--text',
            noPublishedItems: false,
            lockedContent: false,
            requiredContent: {},
            pageExist: true,
            dialogVisible: false,
            confirmationDialogTitle: i18n.t('confirmationDialogTitlePreventEdit'),
            confirmationDialogText: i18n.t('confirmationDialogTextPreventEdit'),
            confirmationDialogSubmitBtn: i18n.t('ok'),
            confirmationDialogCancelBtn: i18n.t('cancel'),
            cdSubmitBtnColor: 'accent',
            image: null,
            description: null,
            checklist: [],
            checklistDraft:[],
            checkedItemsNA: [],
            tabs: 'publish',
            descriptionDraft: null,
            imageUrlDraft:null,
            lockType: null,
            draftVersion: false,
            screen: 'desktop-view'
        }
    },
    async beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.getPrevRoute(from);
        })          
    },
    async created(){
        if(this.$route.params.successfullyCreatedActivity){     
            this.alertMsg = i18n.t('createActivitySuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyCreatedActivityPage){     
            this.alertMsg = i18n.t('createActivityPageSuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyCreatedActivityQuiz){     
            this.alertMsg = i18n.t('createActivityQuizSuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyAddedActivityScorm){     
            this.alertMsg = i18n.t('createActivityScormSuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyCreatedActivityChecklist){     
            this.alertMsg = i18n.t('createActivityChecklistSuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyCreatedActivitySurvey){     
            this.alertMsg = i18n.t('createActivitySurveySuccess');
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyUpdatedActivityChecklistDraft){
            this.alertMsg = i18n.t('editActivityChecklistDraftSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyUpdatedActivityChecklist){
            this.alertMsg = i18n.t('editActivityChecklistSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullySharedActivity){
            this.alertMsg = i18n.t('shareActivitySuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivityPage){
            this.alertMsg = i18n.t('deleteActivityPageSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivityQuiz){
            this.alertMsg = i18n.t('deleteActivityQuizSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivityScorm){
            this.alertMsg = i18n.t('deleteActivityScormSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivityChecklist){
            this.alertMsg = i18n.t('deleteActivityChecklistSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        if(this.$route.params.successfullyDeletedActivitySurvey){
            this.alertMsg = i18n.t('deleteActivitySurveySuccess')
            this.alertType = 'success'
            this.alertValue = true
        }

        if(this.$route.params.successfullyDuplicatedActivityPage){
            this.alertMsg = i18n.t('duplicateActivityPageSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        
        if(this.$route.params.boostersAddedInActivity){
            this.alertMsg = i18n.t('addActivityBoostersSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }

        if (this.$route.params.successfullyConnectedActivityEduAdmin) {
            this.alertMsg = i18n.t("eduAdminConnectedActivitySuccess");
            this.alertType = "success";
            this.alertValue = true;
        }

        if(this.$route.params.preventEditing){
            this.dialogVisible = true
        }
       
        this.loadingData = true
        this.lockedContent = false
        this.checklistId = this.$route.params.checklistId

        await this.getActivityPages()
        
        await this.getActivity()

        if (this.role == 'participant' || this.role == 'guest') {
            //reset navigation
            eventBus.$emit('changeNavigationInActivity', this.activity_pages)
        }

        //create element just for manipulating checkitems images
        if(this.checklist.length > 0){
           await this.changeTemporaryURLs('published')       
        } 
        if(this.checklistDraft.length > 0){
            await this.changeTemporaryURLs('draft')  
        }
        this.loadingData = false       
    },

    methods:{
        mobileOverride(){
            if(this.screen == 'mobile-view'){
                return true;
            }else{
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
            }
        },
        changeView(val){
            this.screen = val
        },
        getPrevRoute(data){
            if(data.name == 'Activities' || data.name == 'ViewHub' || data.name == 'ViewCategory' || data.name == 'SharedWithMe' ||  data.name == 'Dashboard' || data.name == 'AllActivitiesParticipant' || data.name == 'AllHubsParticipant' ||  data.name == 'ActivitiesParticipant'){
                eventBus.$emit('setActivityExitBtn',data)
            }
        },

        async getActivity(){
            try {
                this.hasContent = false
                const response = await getActivity(this.activityId)
                if(response.status == 200) {
                    this.role = response.data.data.attributes.role
                    if (response.data.data.attributes.activity_page_id == null) {
                        this.noPublishedItems = true
                    } else {
                        if (!this.pageExist) {
                            this.$router.push({name: 'PageNotFound'})
                        } else if (this.role != 'booster' && !this.published) {
                            this.$router.push({name: 'PageAccessDenied'})
                        } else if (this.role == 'booster' ||  (this.role != 'booster' && !this.lockedContent)){
                          const response_page = await getActivityChecklist(this.checklistId)
                          if(response_page.status == 200) {
                                const response_checkitems = await getChecklistItems(this.checklistId) 
                                if(response_checkitems.status == 200) {
                                    this.published = response_page.data.data.attributes.published
                                    this.image = this.role == 'booster' ? response_page.data.data.attributes.published_image : response_page.data.data.attributes.image
                                    this.imageUrl = this.role == 'booster' ? response_page.data.data.attributes.published_image_url : response_page.data.data.attributes.image_url
                                    this.description = this.role == 'booster' ? response_page.data.data.attributes.published_description : response_page.data.data.attributes.description
                                    this.editButtonColor = this.published ? "accent" : "warning"
                                    this.editButtonTextColor = this.published ? "white--text" : "black--text"
                                    this.checkboxCertificate =response.data.data.attributes.certificate_enabled

                                    this.checklist = response_checkitems.data.data

                                    //for anonymous users 
                                    //get check status from localStorage
                                    if(this.role == 'NA' && localStorage.getItem('checked-items-'+this.activityId) !== null){
                                        this.checkedItemsNA = JSON.parse(localStorage.getItem('checked-items-'+this.activityId))
                                        for(var index = 0; index < this.checkedItemsNA.length; index++){
                                          const foundChekitem = this.checklist.find(item => item.id == this.checkedItemsNA[index])
                                          if(foundChekitem){
                                              foundChekitem.attributes.checked = true
                                          }
                                        }
                                    }

                                    //end for anonymous users 
                                    if(this.image != null || this.description != null || this.checklist.length > 0){
                                        this.hasContent = true
                                    }
                                }
                                if(this.role == 'booster' ){
                                    this.draftVersion = response_page.data.data.attributes.has_draft
                                    this.imageUrlDraft =  response_page.data.data.attributes.image_url

                                    //there will be always some content there (empty paragraph)
                                    this.descriptionDraft = response_page.data.data.attributes.description
                                    const response_checkitemsDraft = await getChecklistItemsAll(this.checklistId) 
                                    if(response_checkitemsDraft.status == 200){
                                        response_checkitemsDraft.data.data.filter(item => item.attributes.is_deleted == 0).forEach(checklistItem => {
                                            if(this.draftVersion){
                                                this.checklistDraft.push({ title: checklistItem.attributes.title, content: checklistItem.attributes.content, id: this.checklist.length, cid: checklistItem.id});
                                            }
                                        })
                                    }
                                }
                            }
                        }
                      }
                  }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        if(this.isAuth){
                            this.$router.push({name: 'PageNotFound'})
                        }else{
                            this.$router.push({name: 'CustomLogin', query: {referer: this.$route.fullPath}})
                        }
                    }else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    }else if(e.response.status != 401) {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async getActivityPages(){
            try {
                const response = await getActivityPages(this.activityId)
                if (response.status == 200) {
                    if (! response.data.data.find(page => page.attributes.entity_id == this.checklistId && page.attributes.entity_type == 'checklist')) {
                        this.pageExist = false
                    }
                    this.activity_pages = response.data.data.filter(page => page.attributes.is_published == true)
                    if(this.activity_pages.find(page => page.attributes.entity_id == this.checklistId && page.attributes.entity_type == 'checklist')) {
                        this.published = true
                    }
                    var requiredPageId = this.activity_pages.find(page => page.attributes.entity_id == this.checklistId && page.attributes.entity_type == 'checklist').attributes.rule_item_id
                    var requiredPageStatus = this.activity_pages.find(page => page.attributes.entity_id == this.checklistId && page.attributes.entity_type == 'checklist').attributes.rule_fulfilled
                    var requiredDate = this.activity_pages.find(page => page.attributes.entity_id == this.checklistId && page.attributes.entity_type == 'checklist').attributes.rule_available_after
              
                    if(requiredPageId != null && requiredPageStatus == false){
                        this.lockedContent = true
                        this.requiredContent = this.activity_pages.find(page => page.id == requiredPageId)
                        this.lockType = "feedItemDependent"
                    }else if(requiredDate != null && requiredPageStatus == false){
                        this.lockedContent = true
                        this.requiredContent = { date: moment(requiredDate).format('YYYY-MM-DD') + ' ' + moment(requiredDate).format('HH:mm')}
                        this.lockType = "dateDependent"
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
        },
        async changeTemporaryURLs(status){
              if(status == 'published'){
                    for(var index = 0; index < this.checklist.length; index++){
                      var element = document.createElement('div');
                      element.insertAdjacentHTML('beforeend', this.checklist[index].attributes.content);
                      if(element.querySelectorAll("[path]").length > 0){
                          const key = element.querySelector("[path]").attributes.path.nodeValue
                          let data = {
                              data: {
                                  type: "checklists", 
                                  id: this.checklistId,
                                  attributes: {
                                      paths: [element.querySelector("[path]").attributes.path.nodeValue],
                                      space_id: this.spaceId
                                  }
                              }
                          };
                          const response = await changeImageInChecklist(this.checklistId, data)
                          //find and change in html
                          element.querySelector('[path="' + key +'"]').attributes.src.nodeValue=response.data.meta.files[key]                          
                          this.checklist[index].attributes.content = (element.innerHTML).replace(/&amp;/g, '&');
                      }
                    }

                }else{
                      for(var indexDraft = 0; indexDraft < this.checklistDraft.length; indexDraft++){
                        var elementDraft = document.createElement('div');
                        elementDraft.insertAdjacentHTML('beforeend', this.checklistDraft[indexDraft].content);
                        if(elementDraft.querySelectorAll("[path]").length > 0){
                            const key = elementDraft.querySelector("[path]").attributes.path.nodeValue
                                let data = {
                                    data: {
                                        type: "checklists", 
                                        id: this.checklistId,
                                        attributes: {
                                            paths: [elementDraft.querySelector("[path]").attributes.path.nodeValue],
                                            space_id: this.spaceId
                                        }
                                    }
                                };
                            const response = await changeImageInChecklist(this.checklistId, data)
                            //find and change in html
                            elementDraft.querySelector('[path="' + key +'"]').attributes.src.nodeValue=response.data.meta.files[key]
                            this.checklistDraft[indexDraft].content = (elementDraft.innerHTML).replace(/&amp;/g, '&');
                      }
                 }
              }
        }, 
        async setCheckitem(val, id){
            if(this.role != 'booster'){
                if(this.role == 'NA'){
                    if(val){
                        this.checkedItemsNA.push(id)
                        localStorage.setItem('checked-items-'+this.activityId, JSON.stringify(this.checkedItemsNA))
                    }else {
                        this.checkedItemsNA = this.checkedItemsNA.filter(item => item != id)
                        localStorage.setItem('checked-items-'+this.activityId, JSON.stringify(this.checkedItemsNA))
                    }             
                }else {
                    try {
                        let data = {
                            data: {
                                type: "checkitem-attempts", 
                                attributes: {
                                    "checked": val
                                },

                                relationships: {
                                    checklist: {
                                        data: {
                                            type: "checklists",
                                            id: this.checklistId
                                        }
                                    },
                                    checkitem: {
                                        data: {
                                          type: "checkitems",
                                          id: id
                                        }
                                    },
                                    activity: {
                                        data: {
                                            type: "activities",
                                            id: this.activityId
                                        }
                                    }

                                }
                            }
                        };
                        await checkitemAttempt(data);
                        if((this.role == 'participant' || this.role == 'guest') && val && this.activity_pages.find(item => item.attributes.entity_id == this.checklistId && item.attributes.entity_type == 'checklist').attributes.finished == false){
                            eventBus.$emit('checkUpdates', true, this.checkboxCertificate) 
                        }
                    } catch (e) {
                        if(e.response){
                            this.alertValue = true
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError')
                            this.checklist.find(item => item.id === id).attributes.checked = !this.checklist.find(item => item.id === id).attributes.checked
                        }
                    }
                }     
            }
        },

        async resetChecklist(){
            if(this.role == 'booster'){
                this.checklist.forEach((item) => (item.attributes.checked = false));
            }else {
                if(this.role == 'NA'){
                    //this.checklist.forEach((item) => (item.attributes.checked = false)); - not working for anonumous users because checked attribute is not send for anonumous user
                    const response_checkitems = await getChecklistItems(this.checklistId)
                    this.checklist = response_checkitems.data.data
                    //remove from localstorage
                    for(var index = 0; index < this.checklist.length; index++){
                        this.checkedItemsNA = this.checkedItemsNA.filter(item_to_filter => item_to_filter != this.checklist[index].id)
                    }
                    localStorage.setItem('checked-items-'+this.activityId, JSON.stringify(this.checkedItemsNA))
                }else {
                    try {
                        const response = await resetChecklist(this.checklistId);
                        if(response.status == 200) {
                            this.checklist.forEach((item) => (item.attributes.checked = false));
                        }
                    } catch (e) {
                        if(e.response){
                            this.alertValue = true
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError')
                            //if some error occurred show current state
                            const response_checkitems = await getChecklistItems(this.checklistId)
                            this.checklist = response_checkitems.data.data 
                        }
                    }
                }
            }
        }
    },
}
</script>